/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import { getSearchDashboard } from 'actions';
import { matchDatesDashboardCase } from 'util/appUtils';
import SearchEfficiency from './SearchEfficiency';
import Summary from './Summary';
import SearchTrends from './SearchTrends';
import Audience from './Audience';
import Carts from './Carts';
import Profitability from './Profitability';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { app, analytics } = useSelector((store) => store);
  const { search, timeframe } = analytics;
  const { currentShop } = app;
  const { dashboard } = search;
  const { isFetching, projection, meta } = dashboard;

  useEffect(() => {
    const dataIsUnavailable = !isFetching && currentShop;
    const datesIsMatched = meta && matchDatesDashboardCase(meta, timeframe);
    if (dataIsUnavailable || !datesIsMatched) dispatch(getSearchDashboard(currentShop, timeframe));
  }, [timeframe, currentShop]);

  if (isFetching || !projection) return <PlaceholderSpinner />;

  return (
    <Grid container spacing={3} data-testid="cloud-search-dashboard">
      <Summary summary={projection.summary || {}} />
      <Grid item xs={12}>
        <SearchEfficiency search={projection.search} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <Audience audience={projection.audience} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <Carts withProducts={projection.withProducts} />
      </Grid>
      <Grid item xs={12}>
        <Profitability chart={projection.chart} />
      </Grid>
      <Grid item xs={12}>
        <SearchTrends demand={projection.demand} />
      </Grid>
    </Grid>
  );
};

export default Dashboard;
